import React from "react"
import SButton from "components/Common/Button"
import SelectBox from "components/Common/SelectBox"
import { Col, Input, Label, Row, Table } from "reactstrap"
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from "@atlaskit/modal-dialog"

import Button from "@atlaskit/button"
import { UilTimes } from "@iconscout/react-unicons"

import "./style.css"
import { truncateText } from "util/truncate-text"

export default function FileManagerModal(props) {
  const {
    modalOpen,
    closeModal,
    payload,
    fileCategoryOptions,
    fileCategoryValue,
    onDeleteFile,
    handleInput,
    onAddFile,
  } = props
  return (
    <ModalTransition>
      {modalOpen ? (
        <Modal onClose={closeModal} width={"x-large"}>
          <ModalHeader>
            <ModalTitle>ファイル管理</ModalTitle>
            <Button appearance="link" onClick={closeModal}>
              <UilTimes />
            </Button>
          </ModalHeader>
          <ModalBody>
            <Row>
              <Col sm={8}>
                <Table bordered>
                  <thead>
                    <tr>
                      <th style={{ width: "25%" }}>ファイル名</th>
                      <th style={{ width: "25%" }}>ファイルカテゴリー</th>
                      <th style={{ width: "40%" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {payload.files?.length ? (
                      payload.files.map((f, i) => {
                        const link = f.url ? f.url : URL.createObjectURL(f.file)
                        return (
                          <tr key={i}>
                            <td title={f.fileName}>
                              {truncateText(f.fileName, 22)}
                            </td>
                            <td>{f.categoryName}</td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center gap-2">
                                <a
                                  style={{ width: "50%" }}
                                  download
                                  href={link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <SButton className="button">
                                    ダウンロード
                                  </SButton>
                                </a>
                                <SButton
                                  style={{ width: "50%" }}
                                  className="button"
                                  onClick={idx => onDeleteFile(idx)}
                                >
                                  削除
                                </SButton>
                              </div>
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr></tr>
                    )}
                  </tbody>
                </Table>
              </Col>
              <Col sm={4}>
                <SelectBox
                  label="ファイルカテゴリ"
                  options={fileCategoryOptions}
                  value={fileCategoryValue}
                  onChange={e => handleInput(e, "fileCategoryName")}
                  className="mb-3"
                  classNames=""
                  styles={{ menuPortal: base => ({ ...base, zIndex: 1010 }) }}
                />

                <Label>ファイル</Label>
                <Input
                  type="file"
                  className="mb-3"
                  onChange={e => handleInput(e, "fileCategory")}
                  id="fileInput"
                />

                <div className="d-flex justify-content-end align-items-end">
                  <SButton
                    className="button"
                    style={{ width: 150 }}
                    onClick={onAddFile}
                  >
                    登録
                  </SButton>
                </div>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter></ModalFooter>
        </Modal>
      ) : (
        ""
      )}
    </ModalTransition>
  )
}
